import React from 'react';

const MirIcon = () => (
    <svg
        height="28"
        width="64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <linearGradient
                id="m"
                x1=".008%"
                x2="100%"
                y1="50%"
                y2="50%"
            >
                <stop
                    offset="30%"
                    stopColor="#00B4E6"
                />
                <stop
                    offset="100%"
                    stopColor="#088CCB"
                />
            </linearGradient>
        </defs>
        <g
            fill="none"
            fillRule="evenodd"
        >
            <path d="M54.575 0H2.95C1.475 0 0 1.116 0 2.232v22.32C0 26.784 1.475 27.9 4.425 27.9h50.15c2.95 0 4.425-1.116 4.425-3.348V3.348C59 1.116 57.525 0 54.575 0Z"/>
            <path
                d="M20.396 6v.006c-.006 0-1.797-.006-2.275 1.703-.438 1.567-1.672 5.892-1.706 6.012h-.34s-1.263-4.423-1.707-6.018C13.891 5.994 12.094 6 12.094 6H8v13h4.094v-7.72h.341L14.823 19h2.843l2.388-7.715h.342V19h4.093V6h-4.093ZM35.35 6s-1.2.108-1.763 1.362l-2.9 6.359h-.34V6h-4.095v13h3.867s1.256-.114 1.82-1.362l2.842-6.359h.341V19h4.094V6H35.35Zm5.686 5.904V19h4.094v-4.144h4.435a4.429 4.429 0 0 0 4.18-2.952h-12.71.001Z"
                fill="#4DB45E"
                fillRule="nonzero"
            />
            <path
                d="M49.565 6H40.46a6.534 6.534 0 0 0 6.431 5.336h7.019a4.39 4.39 0 0 0 .09-.908A4.43 4.43 0 0 0 49.566 6h-.001Z"
                fill="url(#m)"
            />
        </g>
    </svg>
);

export default MirIcon;
